import React from 'react';
import HTMLReactParser from 'html-react-parser';

import { constructLink } from '../../../../../helper';
import Image from '../../../../Image';
import Carousel from '../../../../Carousel';
import ContentLink from '../../../../ContentLink';

import * as styles from './styles.module.css';

class CarouselLayout extends React.PureComponent {
  constructor(props) {
    super(props);

    let crop = true;
    if (props?.section?.styles?.crop === false) ({ crop } = props.section.styles);

    const themeHeadingStyle = {
      fontFamily: props?.themeData?.typography.heading.name,
      lineHeight: props?.themeData?.typography.heading.lineHeight,
      letterSpacing: props?.themeData?.typography.heading.letterSpacing,
    };

    const themeDefaultStyle = {
      fontFamily: props?.themeData?.typography.default.name,
      fontWeight: props?.themeData?.typography.default.weight,
      lineHeight: props?.themeData?.typography.default.lineHeight,
      letterSpacing: props?.themeData?.typography.default.letterSpacing,
    };

    this.state = {
      crop,
      themeDefaultStyle,
      themeHeadingStyle,
    };
  }

  render() {
    const colorBlack = {
      color: '#000000',
    };

    const cards = [];

    this.props.section.data.map((item, index) => {
      if (item.type === 'IMAGES/IMAGE') {
        const sizes = '100vw';
        const align = item.content.align || 'Left';
        const imageAltStyle = `imageAlt${this.props.themeData?.typography.heading.fontSize}`;
        const imageTextStyle = `imageText${this.props.themeData?.typography.default.fontSize}`;

        let card = (
          <div key={`${this.props.section._id}_${item.content.id}_${index}`} className={`${styles.carouselWrapper}`}>
            <div className={`${styles.carouselImageWrapper}`}>
              <Image
                id={item.content.id}
                url={item.content.src}
                sizes={sizes}
                imageStyleName={`carouselImg${this.state.crop === false ? 'NoCrop' : ''}`}
                images={this.props.images}
                loadingStrategy={this.props.isFirst && index === 0 ? 'eager' : undefined}
              />
              {(this.props.section.styles.alt === true || this.props.section.styles.description === true) &&
                (item.content.alt || item.content.description) && (
                  <>
                    <div className={styles.imageTextWrapperHidden}>
                      {this.props.section.styles.alt === true && (
                        <div className={styles[imageAltStyle]} style={this.state.themeHeadingStyle}>
                          {HTMLReactParser(item.content.alt)}
                        </div>
                      )}
                      {this.props.section.styles.description === true && (
                        <div className={styles[imageTextStyle]} style={this.state.themeDefaultStyle}>
                          {HTMLReactParser(item.content.description)}
                        </div>
                      )}
                    </div>
                    <div className={styles[`imageTextWrapper${align}`]} style={this.props.boxStyle}>
                      {this.props.section.styles.alt === true && (
                        <div
                          className={styles[imageAltStyle]}
                          style={{ ...this.state.themeHeadingStyle, ...colorBlack }}
                        >
                          {HTMLReactParser(item.content.alt)}
                        </div>
                      )}
                      {this.props.section.styles.description === true && (
                        <div
                          className={styles[imageTextStyle]}
                          style={{ ...this.state.themeDefaultStyle, ...colorBlack }}
                        >
                          {HTMLReactParser(item.content.description)}
                        </div>
                      )}
                    </div>
                  </>
                )}
            </div>
          </div>
        );

        if (item.content.linkObj && (item.content.linkObj.src || item.content.linkObj.type)) {
          const key = `${this.props.section._id}_CarouselLink_${index}`;
          const { link, type: linkType } = constructLink(
            item.content.linkObj.type ? item.content.linkObj : item.content.linkObj.src,
            this.props.pagePathList,
            this.props.articlePathList,
            this.props.filePathList,
            this.props.categoryPathList,
            this.props.sectionSlugs,
          );

          card = (
            <ContentLink key={key} openLinkInNewTab={item.content.linkObj.openLinkInNewTab} link={link} type={linkType}>
              {card}
            </ContentLink>
          );
        }

        cards.push(card);
      }

      return null;
    });

    return (
      <div className={`${this.props.full ? '' : 'container'} ${styles[`carouselContainer${this.props.full}`]}`}>
        <div className={`row ${styles.noMargin}`}>
          <div className={`col-12 ${styles.carouselCol}`}>
            <Carousel
              showArrows={this.props.section.styles.arrows}
              showIndicators={this.props.section.styles.indicators}
              autoPlay={this.props.section.styles.autoplay}
              infiniteLoop={this.props.section.styles.infinite}
              interval={this.props.section.styles.interval}
            >
              {cards}
            </Carousel>
          </div>
        </div>
      </div>
    );
  }
}

export default CarouselLayout;
